<template>
  <Header>
    <el-menu
      :default-active="activeIndex"
      background-color="#1D2943"
      text-color="#fff"
      active-text-color="#ffd04b"
      mode="horizontal"
      :class="UI.isMobile ? 'mobile-header-menu' : 'header-menu'"
      @select="handleSelect"
    >
      <el-submenu index="1">
        <template slot="title">首页管理</template>
        <el-menu-item index="homePic">首页轮播图</el-menu-item>
        <el-menu-item index="notices">新闻公告</el-menu-item>
        <el-menu-item index="partners">合作伙伴</el-menu-item>
      </el-submenu>
      <el-menu-item index="userList">用户列表</el-menu-item>

      <el-submenu index="3">
        <template slot="title">信息审核</template>
        <el-menu-item index="orgApprove">单位信息</el-menu-item>
        <el-menu-item index="orgPlayerApprove">专业运动员信息</el-menu-item>
        <el-menu-item index="playerApprove">运动员信息</el-menu-item>
        <el-menu-item index="techOfficer">技术官员信息</el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">赛事/项目</template>
        <el-menu-item index="gamesManager">赛事管理</el-menu-item>
        <el-menu-item index="gameItemsManager">赛事项目管理</el-menu-item>
        <el-menu-item index="pointsManager">积分管理</el-menu-item>
      </el-submenu>
      <el-menu-item index="fileManager">文件管理</el-menu-item>
    </el-menu>
  </Header>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/header.vue';

export default {
  components: {
    Header,
  },

  computed: {
    ...mapState(['UI']),
  },

  data() {
    return {
      activeIndex: 'title',
    };
  },

  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: 'routeChange',
  },

  mounted() {
    this.routeChange();
  },

  methods: {
    routeChange: function () {
      if (this.activeIndex != this.$route.name)
        this.activeIndex = this.$route.name;
    },

    handleSelect: function (key, keyPath) {
      if (key) {
        let query = {};
        if (key == 'orgPlayerApprove') {
          key = 'userApprove';
          query = {
            role: 1,
          };
        } else if (key == 'playerApprove') {
          key = 'userApprove';
          query = {
            role: 2,
          };
        } else if (key == 'techOfficer') {
          key = 'userApprove';
          query = {
            role: 3,
          };
        }

        this.$router.replace({
          name: key,
          query: query,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.header-menu {
  height: 70px;

  li.el-menu-item {
    height: 100%;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  &.el-menu--horizontal {
    border-bottom: none;
  }

  .el-submenu {
    height: 100%;

    text-align: center;
    display: flex;
    align-items: center;

    .el-submenu__title {
      font-weight: 600;
      font-size: 16px;
      height: 70px;
      line-height: 70px;
    }
  }
}

.mobile-header-menu {
  .el-menu-item {
    text-align: center;
    display: flex;
    align-items: center;
    width: 100%;
  }

  &.el-menu--horizontal {
    border-bottom: none;
    width: 100%;
  }

  .el-menu-item.is-active {
    border-bottom: 1px solid #ffd04b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menuHeader.vue